import { useLocation,useSearchParams,useNavigate} from 'react-router-dom';
import { useEffect, useState} from 'react';
import { Clock, BarChart, ArrowUpRight,Bookmark,File} from 'react-feather';
import { SearchHistoryDiv } from '../SearchHistoryDiv';
import util from '@utils/utils'
import { POLICY_EMPTY_FILTERED_TAGS } from '@constants';
import { useConfig } from '../../../../contexts/ConfigContext';
export const SearchInput = (props)=> {
    const {input, setInput,large, rounded,shadow,orgAndNumLoading,orgAndNumData,setSearchK,setQuery,setCurrentSection} = props
    const { pathname } = useLocation();
    const [searchType, setSearchType ] = useState(util.getStorage('research_copilot_policy_search_type') ?? 'AI')
    const { clientId } = useConfig();

    return (
        <div className={`sticky top-0 z-30 shadow-sm ${clientId === 'client-b' ? 'mainContainer' : 'bg-white'}`}>
            <div className={`fixed bottom-4 lg:bottom-0 lg:relative flex gap-8 pl-20 lg:pl-4 pt-6 lg:pb-4 pr-8 lg:pr-4 pb-0 items-center justify-center w-full z-20 ${clientId === 'client-b' ? 'mainContainer' : 'bg-white'}`}>
                {clientId === 'client-b' ? (
                    <label className={`w-full max-w-lg xl:max-w-xl 2xl:max-w-2xl input flex items-center gap-1 md:gap-2 rounded-full ${shadow ? 'shadow-lg' : ''} ${large ? 'input-lg ' : 'input-bordered'}`}>
                        <input 
                            type="text" 
                            className="grow no-traditional no-translate" 
                            placeholder="输入您感兴趣的政策信息..." 
                            value={input} 
                            onChange={(e)=>setInput(e.target.value)}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter') {
                                    setSearchK(input);
                                    // 搜索时设置默认机构筛选条件
                                    if(setQuery){
                                                                        setQuery({
                                    filter_tags: {
                                        ...POLICY_EMPTY_FILTERED_TAGS,
                                        province_list: ['国务院', '国务院/国家发展和改革委员会/国家能源局', '国务院/国家发展和改革委员会']
                                    },
                                    state_grid_related: false
                                });
                                    }
                                    // 确保 currentSection 为 main
                                    if(setCurrentSection){
                                        setCurrentSection('main');
                                    }
                                    // Scroll to top after search
                                    window.scrollTo({
                                        top: 0,
                                        behavior: 'smooth'
                                    });
                                }
                            }}                 
                        />
                        {input && <svg className='cursor-pointer text-gray-400 w-6 h-6 mx-2' fill="none" viewBox="0 0 24 24" stroke="currentColor" onClick={()=>{setInput('')}}>
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>}
                        <span className='flex items-center gap-2 cursor-pointer text-primary font-bold no-translate whitespace-nowrap' onClick={()=>{
                            setSearchK(input);
                            // 搜索时设置默认机构筛选条件
                            if(setQuery){
                                setQuery({
                                    filter_tags: POLICY_EMPTY_FILTERED_TAGS,
                                    state_grid_related: false
                                });
                            }
                            // 确保 currentSection 为 main
                            if(setCurrentSection){
                                setCurrentSection('main');
                            }
                            // Scroll to top after search
                            window.scrollTo({
                                top: 0,
                                behavior: 'smooth'
                            });
                        }}>
                            智能检索
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth='2' stroke="currentColor" className="w-6 h-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                            </svg>
                        </span>
                    </label>
                ) : (
                    <div className="join w-full max-w-3xl shadow-lg rounded-full overflow-hidden">
                        <input 
                        className={`${large ? 'input-lg' : ''} input join-item w-full rounded-l-full border-0 focus:outline-none focus:ring-2 focus:ring-primary/20 bg-white`}
                        placeholder='输入您感兴趣的政策信息...' 
                        value={input} 
                        onChange={(e)=>setInput(e.target.value)}
                        onKeyDown={(event) => {
                            if (event.key === 'Enter') {
                                setSearchK(input);
                                // 搜索时设置默认机构筛选条件
                                if(setQuery){
                                    setQuery({
                                        filter_tags: {
                                            ...POLICY_EMPTY_FILTERED_TAGS,
                                            province_list: ['国务院', '国务院/国家发展和改革委员会/国家能源局', '国务院/国家发展和改革委员会']
                                        },
                                        state_grid_related: false
                                    });
                                }
                                // 确保 currentSection 为 main
                                if(setCurrentSection){
                                    setCurrentSection('main');
                                }
                                // Scroll to top after search
                                window.scrollTo({
                                    top: 0,
                                    behavior: 'smooth'
                                });
                            }
                        }}
                        />
                        <button className={`${large ? 'btn-lg' : ''} btn bg-gradient-to-r from-primary to-primary/90 hover:from-primary/90 hover:to-primary text-white border-0 join-item rounded-r-full font-medium transition-all duration-200 hover:shadow-lg`} onClick={()=>{
                            setSearchK(input);
                            // 搜索时设置默认机构筛选条件
                            if(setQuery){
                                setQuery({
                                    filter_tags: POLICY_EMPTY_FILTERED_TAGS,
                                    state_grid_related: false
                                });
                            }
                            // 确保 currentSection 为 main
                            if(setCurrentSection){
                                setCurrentSection('main');
                            }
                            // Scroll to top after search
                            window.scrollTo({
                                top: 0,
                                behavior: 'smooth'
                            });
                        }}>
                            智能检索
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth='2' stroke="currentColor" className="w-5 h-5">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                            </svg>
                        </button>
                    </div>
                )}
                {(pathname === '/policy' || pathname === '/') && 
                <>
                    <span className='hidden lg:block absolute top-6 right-64'>
                        <span className='flex items-center gap-2'>
                            <BarChart size="16" color="#666c79" strokeWidth="4"/>
                            政策总数：
                            {orgAndNumLoading ? <span className="skeleton h-6 w-16 mb-2"></span> : 
                            <span className='text-primary text-2xl'>
                                {orgAndNumData?.total_num ?? 0}
                            </span>}
                        </span>
                        <span className='flex items-center gap-2'>
                            <Bookmark size="16" color="#666c79" strokeWidth="4"/>
                            重要讲话：
                            {orgAndNumLoading ? <span className="skeleton h-6 w-16 mb-2"></span> : 
                            <span className='text-primary text-2xl'>
                                {orgAndNumData?.important_speech_num ?? 0}
                            </span>}
                        </span>
                    </span>
                    <span className='hidden lg:block absolute top-6 right-8'>
                        <span className='flex items-center gap-2'>
                            <ArrowUpRight size="16" color="#666c79" strokeWidth="4"/>
                            本月新增：
                            {orgAndNumLoading ? <span className="skeleton h-6 w-16 mt-2"></span> : 
                            <span className='text-primary text-2xl'>
                                {orgAndNumData?.monthly_policy_num ?? 0}
                            </span>}
                        </span>
                        <span className='flex items-center gap-2'>
                            <File size="16" color="#666c79" strokeWidth="4"/>
                            政策解读：
                            {orgAndNumLoading ? <span className="skeleton h-6 w-16 mt-2"></span> : 
                            <span className='text-primary text-2xl'>
                                {orgAndNumData?.interpretation_num ?? 0}
                            </span>}
                        </span>
                    </span>

                </>
                }
            </div>
            {(pathname === '/policy' || pathname === '/') && 
            <SearchHistoryDiv 
                // searchAction={searchAction}
                setSearchK={setSearchK}
                setQuery={setQuery}
                setCurrentSection={setCurrentSection}
            />
            }

        </div>

    )
}